<template>
  <div>
    <div v-if="!body.suostujat?.length">
      Ei suostumuksen antajia
    </div>
    <div
      v-for="(suostuja, idx) of body.suostujat"
      :key="idx"
      outlined
      class="pb-3 mb-3"
    >
      <div class="mb-3 helmi-card-title">
        Suostumuksen antaja {{ idx + 1 }}
      </div>
      <v-row>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="suostuja.person.firstName"
            label="Etunimi"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="suostuja.person.lastName"
            label="Sukunimi"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="suostuja.person.socialSecurityNumber"
            label="Henkilötunnus"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="suostuja.person.email"
            label="Sähköposti"
            :rules="[rules.required, rules.email]"
          />
        </v-col>
      </v-row>
      <v-radio-group
        v-model="suostuja.suostujanTyyppi"
        :rules="[rules.required]"
        label="Suostumuksen antajan tyyppi"
      >
        <v-radio
          v-for="(n, index) in suostujanTyyppiOptions"
          :key="index"
          :disabled="['KH', 'LE'].includes(n.value)"
          :label="n.text"
          :value="n.value"
        />
      </v-radio-group>

      <v-radio-group
        v-model="suostuja.sellerSocialSecurityNumber"
        :rules="[rules.required]"
        label="Henkilö jolle suostumus tarvitaan"
      >
        <v-radio
          v-for="(n, index) in body.sellers.filter(s => s.roles.includes('SIGNER'))"
          :key="index"
          :label="`${n.person.firstName} ${n.person.lastName} (${n.person.socialSecurityNumber})`"
          :value="n.person.socialSecurityNumber"
        />
      </v-radio-group>

      <v-divider
        v-if="idx < body.suostujat?.length - 1 && body
        .suostujat?.length > 1"
        class="mt-5"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),
  computed: {
    suostujanTyyppiOptions() {
      if (this.config.data && this.config.data.options.suostujanTyyppi) {
        return this.config.data.options.suostujanTyyppi.values
          .map(item => ({ text: item.displayText.fin, value: item.value }));
      }
      return [];
    },
  },
};
</script>
